/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Attach_Type_DocumentInputs */

const cs_chat_attach_type_document = /** @type {(inputs: Chat_Attach_Type_DocumentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dokument`)
};

const en_chat_attach_type_document = /** @type {(inputs: Chat_Attach_Type_DocumentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Document`)
};

/**
* | output |
* | --- |
* | "Document" |
*
* @param {Chat_Attach_Type_DocumentInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const chat_attach_type_document = /** @type {((inputs?: Chat_Attach_Type_DocumentInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Attach_Type_DocumentInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_chat_attach_type_document(inputs)
	return cs_chat_attach_type_document(inputs)
});